
import { faSearch, faSpinner } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'InputSearch',

  props: {
    value: {
      type: String,
      default: ''
    },

    isDisabled: {
      type: Boolean,
      default: false
    },

    isTransparent: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: null
    },

    isLoading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      faSearch,
      faSpinner
    }
  }
}
